import React, { useState, useEffect, Fragment } from 'react'
//import rgbToHex from './utils'

const SingleColor = ({ rgb, weight, index, hexColor }) => {
  const [alert, setAlert] = useState(false)
  const bcg = rgb.join(',')
  //const hex = rgbToHex(...rgb)
  const hexValue = `#${hexColor}`
  useEffect(() => {
    const timeOut = setTimeout(() => {
      setAlert(false)
    }, 3000)
    return () => {
      clearTimeout(timeOut)
    }
  }, [alert])
  return (
    <Fragment>
      <article
        onClick={() => {
          setAlert(true)
          navigator.clipboard.writeText(hexValue)
        }}
        className={`color ${index > 10 && 'color-light'}`}
        style={{ backgroundColor: `rgb(${bcg})` }} >
        <p className="percent-value">
          {weight}%
        </p>
        <p className="color-value">
          {hexValue}
        </p>
        {alert && <p className="alert">copied to clipboard</p>}
      </article>
    </Fragment>
  )
}

export default SingleColor
